import React from 'react';

import { useSelector } from 'react-redux';
import { getLogoApp } from 'store/globalApp';

const Logo = () => {
  const logoApp = useSelector(getLogoApp);

  if (!logoApp) return <></>;
  return <img alt="Alia" src={logoApp} height={55} />;
};

export default Logo;
